var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 44.0085C24.0045 45.386 25.1225 46.5 26.5 46.5H28C29.3805 46.5 30.5 47.619 30.5 49C30.5 50.381 29.381 51.5 28 51.5H27.717C26.76 51.5 26 52.26 26 53.1975C26 54.193 26.807 55 27.8025 55H52.25C53.213 55 53.995 54.222 54 53.2585V53.25C54.005 52.285 53.224 51.5 52.2585 51.5H52C50.8955 51.5 50 50.6045 50 49.5C50 48.3955 50.8955 47.5 52 47.5H53.5C54.8805 47.5 56 46.3805 56 45C56 43.6195 54.8805 42.5 53.5 42.5C52.6715 42.5 52 41.8285 52 41C52 40.1715 52.6715 39.5 53.5 39.5H53.25C54.769 39.5 56 38.269 56 36.75C56 35.231 54.769 34 53.25 34H51.798C50.6935 34 49.798 33.1045 49.798 32C49.798 30.8955 50.6935 30 51.798 30H53.25C54.4925 30 55.5 28.9925 55.5 27.75C55.5 26.5075 54.4925 25.5 53.25 25.5H39.5H26.5C25.3955 25.5 24.5 26.3955 24.5 27.5C24.5 28.6045 25.3955 29.5 26.5 29.5H32.75C33.7165 29.5 34.5 30.2835 34.5 31.25C34.5 32.2165 33.7165 33 32.75 33H26.5C25.3955 33 24.5 33.8955 24.5 35C24.5 36.1045 25.3955 37 26.5 37H27.25C28.4925 37 29.5 38.0075 29.5 39.25C29.5 40.4925 28.4925 41.5 27.25 41.5H26.5C25.116 41.5 23.9955 42.6245 24 44.0085Z",
    fill: "url(#paint0_radial_156_226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.264 37.7895C27.2055 37.7895 27.191 37.7605 27.22 37.7165L27.5265 37.322C27.5555 37.278 27.6285 37.249 27.687 37.249H32.9015C32.96 37.249 32.9745 37.293 32.9455 37.3365L32.697 37.7165C32.668 37.7605 32.595 37.804 32.551 37.804L27.264 37.7895Z",
    fill: "url(#paint1_linear_156_226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0585 39.1335C25 39.1335 24.9855 39.1045 25.0145 39.0605L25.321 38.666C25.35 38.622 25.423 38.593 25.4815 38.593H32.142C32.2005 38.593 32.2295 38.637 32.215 38.6805L32.098 39.031C32.0835 39.0895 32.025 39.1185 31.9665 39.1185L25.0585 39.1335Z",
    fill: "url(#paint2_linear_156_226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.593 40.477C28.5345 40.477 28.52 40.433 28.549 40.3895L28.7535 40.0245C28.7825 39.9805 28.841 39.937 28.8995 39.937H31.821C31.8795 39.937 31.9085 39.981 31.9085 40.039L31.8795 40.3895C31.8795 40.448 31.821 40.4915 31.7775 40.4915L28.593 40.477Z",
    fill: "url(#paint3_linear_156_226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7551 37.5265C42.8351 37.76 42.2066 37.9355 41.3011 38.169C41.0821 38.2275 41.0676 38.242 40.8776 38.023C40.6586 37.7745 40.4976 37.614 40.1911 37.468C39.2711 37.015 38.3801 37.1465 37.5471 37.687C36.5541 38.3295 36.0426 39.279 36.0571 40.462C36.0716 41.6305 36.8751 42.5945 38.0291 42.755C39.0221 42.8865 39.8551 42.536 40.5121 41.791C40.6436 41.6305 40.7606 41.455 40.9066 41.2505C40.3806 41.2505 39.7236 41.2505 38.0876 41.2505C37.7811 41.2505 37.7076 41.0605 37.8101 40.8125C38.0001 40.3595 38.3506 39.6 38.5551 39.2205C38.5991 39.133 38.7011 38.987 38.9201 38.987C39.6651 38.987 42.4111 38.987 44.2371 38.987C44.2081 39.3815 44.2081 39.776 44.1496 40.17C43.9891 41.2215 43.5946 42.1855 42.9521 43.033C41.9006 44.4205 40.5276 45.2825 38.7891 45.516C37.3576 45.706 36.0286 45.4285 34.8601 44.552C33.7791 43.734 33.1656 42.653 33.0051 41.3095C32.8151 39.7175 33.2826 38.286 34.2466 37.03C35.2836 35.6715 36.6566 34.81 38.3366 34.503C39.7096 34.2545 41.0241 34.4155 42.2071 35.2185C42.9811 35.7295 43.5361 36.431 43.9016 37.278C43.9886 37.41 43.9301 37.483 43.7551 37.5265Z",
    fill: "url(#paint4_linear_156_226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5896 45.604C47.2606 45.575 46.0481 45.195 45.0256 44.3185C44.1636 43.5735 43.6236 42.624 43.4481 41.4995C43.1851 39.849 43.6381 38.3885 44.6311 37.0885C45.6976 35.6865 46.9826 34.956 48.7211 34.649C50.2111 34.386 51.6131 34.532 52.8841 35.394C54.0381 36.183 54.7536 37.249 54.9436 38.6515C55.1921 40.6235 54.6221 42.23 53.2636 43.603C52.2996 44.5815 51.1166 45.195 49.7581 45.4725C49.3636 45.5455 48.9696 45.5605 48.5896 45.604ZM52.0661 39.703C52.0516 39.513 52.0516 39.367 52.0221 39.221C51.7591 37.775 50.4301 36.957 49.0426 37.2785C47.6841 37.585 46.8076 38.447 46.4866 39.82C46.2236 40.9595 46.7786 42.113 47.8306 42.5805C48.6341 42.931 49.4371 42.887 50.2116 42.493C51.3651 41.894 51.9931 40.959 52.0661 39.703Z",
    fill: "url(#paint5_linear_156_226)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_156_226",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 40.25) rotate(180) scale(15.3875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#F8EECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#FDF4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_156_226",
    x1: 35.4975,
    y1: 54.119,
    x2: 30.5825,
    y2: 39.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4CC5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6BD4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AE4FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_156_226",
    x1: 33.767,
    y1: 54.6835,
    x2: 28.8525,
    y2: 39.6195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4CC5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6BD4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AE4FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_156_226",
    x1: 34.826,
    y1: 54.338,
    x2: 29.911,
    y2: 39.2745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4CC5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6BD4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AE4FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_156_226",
    x1: 42.4971,
    y1: 51.8355,
    x2: 37.5821,
    y2: 36.7715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4CC5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6BD4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AE4FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_156_226",
    x1: 52.0281,
    y1: 48.7255,
    x2: 47.1131,
    y2: 33.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#4CC5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#6BD4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AE4FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/go.ef27033c7f8389718d9dfb63ea1382e8.svg";
export { ForwardRef as ReactComponent };